import { BaseType } from '@globalmed/atlas-ui';
import styles from './Stepper.module.css';

type TProps = {
  steps: BaseType[];
  activeStepId: string;
};

/**
 * Numbered list of workflow steps with the current one highlighted.
 * Steps are informational only — they are not links.
 * @param props - Component props.
 * @param props.steps - Steps in order, each with a stable `id` and a `title`.
 * @param props.activeStepId - Id of the current step.
 * @returns The Stepper component.
 */
export const Stepper = ({ steps, activeStepId }: TProps) => (
  <ol className={styles.stepper}>
    {steps.map(({ id, title }, index) => {
      const isActive = id === activeStepId;
      return (
        <li
          key={id}
          className={styles.step}
          data-active={isActive}
          aria-current={isActive ? 'step' : undefined}
        >
          <span className={styles.number} aria-hidden="true">
            {index + 1}
          </span>
          <span className={styles.label}>{title}</span>
        </li>
      );
    })}
  </ol>
);
